/** @jsxImportSource @emotion/react */
import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import { symbolCurrency } from '@lbs/currency'
import { css } from '@emotion/react'
import { useStore } from '../../stores'

const Currency: FC<{
  color?: string
}> = observer(({ color }) => {
  const { applicationStore } = useStore()
  return (
    <span
      css={css`
        color: ${color || 'inherit'};
      `}>
      {symbolCurrency[applicationStore.currency]}
    </span>
  )
})

export default Currency
